import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '../plugins/axios'
window.wx = require('weixin-js-sdk');
import { VeLine } from 'v-charts-v2/lib/index.esm'

import {
  Cell, CellGroup, Dialog, Button,
  Icon, Tab, Tabs, List,
   Checkbox, Calendar, Picker,  RadioGroup, Radio,
    CheckboxGroup, Form, Field, Search,
    Collapse, CollapseItem, PullRefresh,
    Tabbar, TabbarItem, DatetimePicker,
    Popup, Uploader, NavBar, Loading
  } from 'vant';
Vue.component(VeLine.name, VeLine)
Vue.use(Popup)
Vue.use(Icon)
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Uploader);
Vue.use(PullRefresh);
Vue.use(Search);
Vue.use(Tabbar);
Vue.use(TabbarItem);
Vue.use(Form);
Vue.use(Field);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(DatetimePicker);
Vue.use(List);
Vue.use(Cell);
Vue.use(NavBar);
Vue.use(CellGroup);
Vue.use(Button);
Vue.use(Checkbox);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(CheckboxGroup);
Vue.use(Dialog)
Vue.use(Calendar)
Vue.use(Picker)
Vue.use(Loading);

// import vConsole from 'vconsole'
// var vc = new vConsole();
Vue.config.productionTip = false
window.defaultStore = store
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

